import React from "react";
import { CardElement } from "@stripe/react-stripe-js";

const CARD_OPTIONS = {
  hidePostalCode: true,
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#00A78E",
      color: "#18332e",
      fontWeight: "500",
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      "::placeholder": {
        color: "#8aa39c",
      },
      ":-webkit-autofill": {
        color: "#18332e",
      },
    },
    invalid: {
      iconColor: "#c14953",
      color: "#c14953",
    },
  },
};

export const CardField = ({ onChange }) => (
  <div className="CheckoutField CheckoutField--card">
    <label className="CheckoutFieldLabel">Card details</label>
    <div className="CheckoutFieldSurface CheckoutFieldSurface--card">
      <CardElement options={CARD_OPTIONS} onChange={onChange} />
    </div>
  </div>
);

export const Field = ({
  label,
  id,
  type,
  placeholder,
  required,
  autoComplete,
  value,
  onChange,
}) => (
  <div className="CheckoutField">
    <label htmlFor={id} className="CheckoutFieldLabel">
      {label}
    </label>
    <div className="CheckoutFieldSurface">
      <input
        className="CheckoutTextInput"
        id={id}
        type={type}
        placeholder={placeholder}
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
      />
    </div>
  </div>
);
